import BigNumber from 'bignumber.js'

import { Iterable, Order, pipe, BigNumber as BigNumber_ } from '@blade/std-lib'
import { WalletAddress } from '@root/entities/wallet'

import * as UserProfileHoldingsWalletAsset from './user-profile-holdings-wallet-asset'

import type { Network } from '@root/entities/network'
import type { UserProfileHoldingsWalletDto } from '@root/shared/api/UserApi'
import type { TokenLogosHost } from '@root/shared/models'

export interface UserProfileHoldingsWallet {
  address: WalletAddress
  name: string
  assets: ReadonlyArray<UserProfileHoldingsWalletAsset.UserProfileHoldingsWalletAsset>
  totalBalanceUsd: BigNumber
  totalBalanceNative: BigNumber
  network: Network.Network
}

export const fromDto = (
  dto: UserProfileHoldingsWalletDto,
  options: {
    network: Network.Network
    tokenLogosHost: TokenLogosHost
  },
): UserProfileHoldingsWallet => {
  const assets = dto.assets.map((assetDto) =>
    UserProfileHoldingsWalletAsset.fromDto(assetDto, options),
  )
  return {
    address: WalletAddress(dto.address),
    network: options.network,
    name: dto.name ?? '',
    assets,
    totalBalanceUsd: pipe(
      assets,
      Iterable.reduce(BigNumber(0), (acc, asset) => acc.plus(asset.balanceUsd)),
    ),
    totalBalanceNative: pipe(
      assets,
      Iterable.reduce(BigNumber(0), (acc, asset) =>
        acc.plus(asset.balanceNative),
      ),
    ),
  }
}

export const cmpByTotalBalanceUsdAsc = Order.mapInput(
  BigNumber_.order,
  (x: UserProfileHoldingsWallet) => x.totalBalanceUsd,
)
export const cmpByTotalBalanceUsdDesc = Order.flip(cmpByTotalBalanceUsdAsc)

export const cmpByAssetsCountAsc = Order.mapInput(
  Order.Number,
  (x: UserProfileHoldingsWallet) => x.assets.length,
)
export const cmpByAssetsCountDesc = Order.flip(cmpByAssetsCountAsc)
